import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../../components/Carousel';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import './ProjectPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2014-02-11', displayDate: 'February 11, 2014' };

const carouselSlides = [
  {
    backgroundImage: '/images/banner_inetanalytics.png',
    content: (
      <>
        <p>Your software platform for making Internet measurements easy.</p>
        <p>
          Internet Analytics is an integrated environment that allows you to manage your Internet experiments from a
          single location. The extensibility feature makes it possible to add custom tools, suitable to your
          measurements needs.
        </p>
        <p>
          Both integrated and custom tools benefit from a set common functions, such as database support to store your
          data, and distributed services like PlanetLab to run worldwide experiments.
        </p>
      </>
    ),
  },
  {
    backgroundImage: '/images/banner_mercury.png',
    content: (
      <>
        <p>Today, the Internet Service Provider (ISP) market is very competitive.</p>
        <p>
          When ISPs compete for customers with the latest best offers, a question that begs for answers is: how well is
          your ISP connected to your favorite web sites?
        </p>
        <p>Help us find out, by joining our Mercury Internet measurement project and testing your Internet connection.</p>
        <p>
          <Link
            to="/projects/inetanalytics/mercury"
            title="Collaborate to the Mercury Internet measurement project."
          >
            I want to participate...
          </Link>
        </p>
      </>
    ),
  },
  {
    backgroundImage: '/images/banner_planetlab.png',
    content: (
      <>
        <p>The software that makes it easy to manage your PlanetLab experiments.</p>
        <p>
          The PlanetLab Manager is a desktop application that allows you to configure the PlanetLab site, nodes and
          slices for your experiments. Using the integrated secure shell (SSH) console you can run commands directly on
          the PlanetLab nodes.
        </p>
        <p>
          <Link
            to="/projects/inetanalytics/planetlab"
            title="Go to the PlanetLab Manager web page."
          >
            More information...
          </Link>
        </p>
      </>
    ),
  },
];

const InetAnalyticsPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  return (
    <>
      <Carousel slides={carouselSlides} />
      <div className="project-page" id="top">
        <h1 className="title">Internet Analytics</h1>
      <p>Your software platform for making Internet measurements easy.</p>
      <p>
        Internet Analytics is an integrated environment that allows you to manage your Internet experiments from a single
        location. The extensibility feature makes it possible to add custom tools, suitable to your measurements needs.
      </p>
      <p>
        Both integrated and custom tools benefit from a set common functions, such as database support to store your data,
        and distributed services like PlanetLab to run worldwide experiments.
      </p>

      <div className="project-row" style={{ flexDirection: 'row', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/planetlab/PlmSites.png"
          alt="Manage the PlanetLab Sites."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <h1>PlanetLab Manager</h1>
          <p>
            Have you ever run distributed Internet experiments using PlanetLab? Have you ever wondered how you can focus
            on your research questions, rather than how to connect and manage your PlanetLab nodes? The PlanetLab
            Manager is your answer.
          </p>
          <p>
            The PlanetLab Manager is a software that simplifies the way you manage your distributed experiments using
            the PlanetLab platform.
          </p>
          <p>It helps you visualize the distribution of your slices and nodes.</p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <div className="project-row" style={{ flexDirection: 'row-reverse', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/planetlab/PlmSlice.png"
          alt="Configure Your PlanetLab Slice."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <h1>Configure Your Slice</h1>
          <p>
            The slice management interface enables you to choose the nodes for your slice, which are relevant for your
            experiment.
          </p>
          <p>
            PlanetLab node selection is available by location, status or slice, simplifying the configuration of slices
            with many nodes.
          </p>
          <p>Node status is displayed in real-time, informing you on which nodes are unavailable at the moment.</p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <div className="project-row" style={{ flexDirection: 'row', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/planetlab/PlmSession.png"
          alt="Connect to PlanetLab Nodes."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <h1>Connect to Nodes</h1>
          <p>Once you configured your slice, there is no need to switch to a different tool!</p>
          <p>
            The integrated Secure Shell console enables you to immediately create an SSH connection to the nodes you have
            just configured.
          </p>
          <p>
            Secure sessions to multiple nodes are maintained in parallel, making it easy to switch between different
            nodes, execute programs simultaneously, or compare data results.
          </p>
        </div>
      </div>

      <p style={{ marginTop: 'var(--spacing-lg)' }}>
        <Link to="/projects/inetanalytics/planetlab">PlanetLab Manager</Link> |{' '}
        <Link to="/projects/inetanalytics/mercury">Mercury Client</Link>
      </p>
      <p className="update">Last updated: February 11, 2014</p>
      </div>
    </>
  );
};

export default InetAnalyticsPage;
